// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:slug\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/studio/:tool*?\",\"regex\":\"^/studio(?:/(.*))?$\",\"paramNames\":[\"tool\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/case-studies\"},{\"path\":\"/consult\"},{\"path\":\"/consulting\"},{\"path\":\"/contact\"},{\"path\":\"/download\"},{\"path\":\"/free-templates\"},{\"path\":\"/free-templates/success\"},{\"path\":\"/hire\"},{\"path\":\"/local\"},{\"path\":\"/products\"},{\"path\":\"/resume\"},{\"path\":\"/scan\"},{\"path\":\"/solutions\"},{\"path\":\"/video-walkthroughs\"}],\"isrRoutes\":[]}";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["_sentryTunnelRouteMode"] = "rewrite";globalThis["_sentryNextJsVersion"] = "16.4.4";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://5af50be016d6fa2cb9c0f076bbbb2b21@o4510512900931584.ingest.us.sentry.io/4510512902963200",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
